import React from "react";
import {useSelector} from "react-redux";
import DesktopActiveRoomTabItem from "./DesktopActiveRoomTabItem";

function DesktopActiveRoomTabs() {
    const enteredRooms = useSelector(store => store.rooms);
    return (
        <div className="header-active-games">
            <div className="header-active-games-wrapper">
                {
                    Object.keys(enteredRooms)?.map((roomId, index) => {
                        const room = enteredRooms?.[roomId]
                        if (!room?.isVisibleRoom && !room?.isViewRoom && !room?.historyRoomPlayer) return;
                        return <DesktopActiveRoomTabItem
                            key={index}
                            id={roomId}
                            state={room?.status}
                            isViewRoom={room?.isViewRoom}
                            isHistoryRoom={room?.historyRoomPlayer}
                            isTournamentRoom={room?.tournamentId}
                            notifier={room?.notifier}
                        />
                    })
                }
            </div>
        </div>
    )
}

export default DesktopActiveRoomTabs;
